module.exports = __webpack_public_path__ + "img/mobile scanner stand38.50fabd21.jpg";